/**
 * Takes in a collection of objects and verifies at least one matches
 *
 * @param configurations A collection of variables that should or should not match
 *
 * @example
 * doesConfigurationMatch(
 *  { matching: [truthyVariable1, truthyVariables2], notMatching: [falseyVariable1] },
 * ); // true
 *
 * @example
 * doesConfigurationMatch(
 *  { matching: [truthyVariable1, truthyVariables2], notMatching: [falseyVariable1] },
 *  { matching: [truthyVariable1, truthyVariables2], notMatching: [truthyVariable1] },
 * ); // true (first one matches still)
 *
 * @example
 * doesConfigurationMatch(
 *  { matching: [truthyVariable1, fasleyVariables2], notMatching: [falseyVariable1] },
 *  { matching: [truthyVariable1, truthyVariables2], notMatching: [truthyVariable1] },
 * ); // false (first config has falsey in match, 2nd has truthy in not-match)
 */
export function doesConfigurationMatch(...configurations: ConfigurationMatchType[]): boolean {
  return configurations.some(configuration => matchConfig(configuration.matching, configuration.notMatching));
}

const matchConfig = (matching: any[] = [], notMatching: any[] = []) => {
  for (let i = 0; i < matching.length; i++) {
    if (!matching[i]) return false;
  }

  for (let i = 0; i < notMatching.length; i++) {
    if (notMatching[i]) return false;
  }

  return true;
};

export type ConfigurationMatchType = ConfigurationMatchTypeMatch | ConfigurationMatchTypeNoMatch;

export type ConfigurationMatchTypeMatch = {
  matching: any[];
  notMatching?: any[];
};

export type ConfigurationMatchTypeNoMatch = {
  matching?: any[];
  notMatching: any[];
};
